module.exports = __webpack_public_path__ + "img/applying_behavior_change_toprivate_sector.54d98d54.jpg";